



































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import axios from "@/plugins/axios";
import { GetIdArr } from "@/utils/base";
import {
  GetDictionaryData,
  GetKepuList,
  DelKepu,
  PatchEditKepu,
} from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
import DictionaryManage from "../components/dictionary-manage.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
    DictionaryManage,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private addType: any = "";
  private data: any[] = [];
  private types: any[] = []; // 课程类别
  private types2: any[] = []; // 内容领域
  private creators: any[] = [];
  private scoreFunList: any[] = [];
  private temTypes: any[] = [];
  private editCrfData: any = {};
  private edit: any = false;
  private ifShowAddLiangbiao: any = false;
  private manageType: any = "";
  private ifShowManage: any = false;
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private editStatus(item: any) {
    let type: any = "";
    if (item.check_status === "未发布") {
      type = "已发布";
    } else if (item.check_status === "已发布") {
      type = "未发布";
    }

    PatchEditKepu(this, item.id, { check_status: type }).then((res: any) => {
      this.$message.success(type == "未发布" ? "撤回成功！" : "发布成功！");
      this.getList();
    });
  }
  private go() {
    this.$router.push("/main/manage/feedback");
  }
  private openAdd() {
    this.addType = "";
    this.ifShowEdit = true;
  }
  private addSure() {
    if (!this.addType) {
      this.$message.warning("请选择类别");
      return;
    }
    this.$router.push({
      path: "/main/manage/edit",
      query: {
        type: this.addType,
      },
    });
  }
  private openManage(type: any) {
    this.manageType = type;
    this.ifShowManage = true;
  }
  private saveManage() {
    if (this.manageType == "课程类别") {
      this.getType();
    } else if (this.manageType == "内容领域") {
      this.getType2();
    }
  }
  private getType() {
    const params: any = {
      params: {
        values: "课程类别",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types = res.data;
    });
  }
  private getType2() {
    const params: any = {
      params: {
        values: "内容领域",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types2 = res.data;
    });
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/manage/edit",
      query: {
        id: item.id,
      },
    });
  }
  private delTem(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelKepu(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
      });
    });
  }
  getList() {
    console.log(this.filters);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
        name: this.filters.search,
      },
    };
    if (this.filters["类别"]) {
      params.params.file_type = this.filters["类别"];
    }
    if (this.filters["状态"]) {
      params.params.check_status = this.filters["状态"];
    }
    if (this.filters["内容领域"]) {
      params.params.content_type = this.filters["内容领域"].id;
    }
    if (this.filters["课程类别"]) {
      params.params.content_level = this.filters["课程类别"].id;
    }
    localStorage.setItem("kepuListFilter", JSON.stringify(this.filters));
    GetKepuList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("kepuListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("kepuListFilter") as any);
    }
    this.getList();
    this.getType();
    this.getType2();
  }
}
